import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { FieldType } from '@ngx-formly/core';

@Component({
	selector: 'formly-field-button',
	template: `
		<div [class]="props.class">
			<button
				[type]="props.type"
				mat-button
				[class]="props.buttonClass"
				[disabled]="props?.disabled"
				[color]="props.color"
				(click)="onClick($event)"
			>
				{{ to.text }}
			</button>
		</div>
	`,
	standalone: true,
	imports: [MatButtonModule],
})
export class FormlyFieldButtonComponent extends FieldType {
	onClick($event) {
		if (this.props.onClick) {
			this.props.onClick($event);
		}
	}
}
